import { getLinkToken, getUrlParameters, getViewerTimeInfo, isNoTrackView } from '../commonUtil/util';
import { startSession, endSession, reportClientLog } from '../service/ViewerService';
import { getUniqueInteractionCookie } from './cookieUtil';
import ApplicationEntity from './appEntity';
import { LOG_TYPE } from './constants';

const LOCAL_SESSION_IDLE_ALERT = 15 * 60 * 1000;
let handleSessionTimeoutCallback = null;

let sessionTimer;
let sessionInitialized = false;

export const clearSessionTimer = () => {
    if (sessionTimer) {
        clearTimeout(sessionTimer);
        sessionTimer = null;
    }
};

export const resetSessionTimer = () => {
    clearSessionTimer();
    const sessionCheckingTimer = setTimeout(handleSessionTimeoutCallback, LOCAL_SESSION_IDLE_ALERT);
    sessionTimer = sessionCheckingTimer;
};

export const initialSession = (callback) => {
    clearSessionTimer();
    handleSessionTimeoutCallback = callback;
    sessionTimer = null;
};

export const hasInitializedSessionTimer = () => !!handleSessionTimeoutCallback;

// TODO: remove the sessionInitialized and related logs after we confirm
// TODO: remove getUniqueInteractionCookie and related logs after we confirm
export const createSession = async (isExpired, onlyFunctionCookies, isStrictlyNecessaryCookies) => {
    if (isNoTrackView()) {
        return '';
    }

    if (onlyFunctionCookies) {
        return '';
    }

    if (isStrictlyNecessaryCookies) {
        return '';
    }

    if (isExpired) {
        return '';
    }

    if (!getUniqueInteractionCookie()) {
        const extraInfo = {
            uniqueCookie: getUniqueInteractionCookie()
        };
        const logInfo = {
            LogType: LOG_TYPE.ERROR,
            Message: 'Robot check come into createSession!',
            ExtraInfo: extraInfo
        };
        reportClientLog(logInfo);

        return '';
    }

    if (sessionInitialized) {
        const extraInfo = {
            sessionInitialized,
            sessionId: ApplicationEntity.getInstance().sessionId
        };
        const logInfo = {
            LogType: LOG_TYPE.ERROR,
            Message: 'Finding the Session associated is empty',
            Detail: 'Session initialized in createSession',
            ExtraInfo: extraInfo
        };
        reportClientLog(logInfo);
    }

    const linkToken = getLinkToken();
    const urlParameters = getUrlParameters();
    const timeZone = 0 - (new Date().getTimezoneOffset() / 60);
    const timeZoneInfo = getViewerTimeInfo();

    const startSessionResult = await startSession(linkToken, { UrlParameters: urlParameters, TimeZone: timeZone, TimeZoneInfo: timeZoneInfo });

    if (startSessionResult && startSessionResult.sessionId) {
        sessionInitialized = true;
        return startSessionResult.sessionId;
    }

    const extraInfo = {
        startSessionResult: JSON.stringify(startSessionResult)
    };
    const logInfo = {
        LogType: LOG_TYPE.ERROR,
        Message: 'Create session failed',
        Detail: 'Did not get sessionId after calling startSession API',
        ExtraInfo: extraInfo
    };
    reportClientLog(logInfo);

    return '';
};

export const closeSession = () => {
    endSession(ApplicationEntity.getInstance().tenant, ApplicationEntity.getInstance().sessionId);
};
